import { Stack } from './layouts';
import OverviewDetailRow from './OverviewDetailRow';
import { useTranslation } from 'react-i18next';

const AdvisorDetails = ({name, email, phone_number}) => {
    const { t } = useTranslation();

    return (
        <div>
            <b>{t('Jouw adviseur')}</b>
            <Stack space={'none'} divider={'default'}>
                <OverviewDetailRow
                    descriptor={t('Naam')}
                    value={name}
                    hideIfEmpty
                />
                <OverviewDetailRow
                    descriptor={t('Email')}
                    value={email}
                    hideIfEmpty
                />
                <OverviewDetailRow
                    descriptor={t('Telefoonnummer')}
                    value={phone_number}
                    hideIfEmpty
                />
            </Stack>
        </div>
    );
}

export default AdvisorDetails;